/** @jsxImportSource @emotion/react */
import React from 'react';
import { DatePicker, Form, Input, Modal } from 'antd';
import commonStyles from '../../../../styles/commonStyles';
import { resolveEditableEventDateLabel } from '../utils';
import type { PlantingEvent } from '../../../../types/plantingEvents';
import type { FormInstance } from 'antd';
import dayjs from 'dayjs';

interface Props {
  open: boolean;
  editingEvent: PlantingEvent | null;
  form: FormInstance<{ eventDate: dayjs.Dayjs | null; notes: string }>;
  saving: boolean;
  onSave: () => void;
  onCancel: () => void;
}

const EditEventModal: React.FC<Props> = ({
  open,
  editingEvent,
  form,
  saving,
  onSave,
  onCancel,
}) => (
  <Modal
    title="Корректировка события"
    open={open}
    onCancel={onCancel}
    onOk={onSave}
    okText="Сохранить"
    cancelText="Отмена"
    confirmLoading={saving}
  >
    <Form form={form} layout="vertical">
      <Form.Item
        label={resolveEditableEventDateLabel(editingEvent)}
        name="eventDate"
        rules={[{ required: true, message: 'Укажите дату события' }]}
      >
        <DatePicker format="DD.MM.YYYY" css={commonStyles.fullWidth} />
      </Form.Item>
      <Form.Item label="Комментарий" name="notes">
        <Input.TextArea rows={4} placeholder="Причина корректировки или примечание" />
      </Form.Item>
    </Form>
  </Modal>
);

export default EditEventModal;
